const key = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAN6PbHS64oBjzsGdlPtdKhUajaP17U4IQ/XjpYiIevAjmiIrLkYQfLbisUGvzu0w65DVbw5MtIdr840bwjN9wWkCAwEAAQ=="
export const privateKey = key
